import RangePicker from './range-picker';
export type { RangePickerHandle } from './range-picker';

export default RangePicker;
